export default {"src":"/_next/static/media/tracking-performance.5e3d0a7b.svg","height":1369,"width":1152,"blurWidth":0,"blurHeight":0};